import { gql } from '@apollo/client';

export const upsertLeadCadenceState = gql`
  mutation upsertLeadCadenceState($object: lead_cadence_state_insert_input!) {
    insert_lead_cadence_state_one(
      object: $object
      on_conflict: {
        constraint: lead_cadence_state_lead_id_key
        update_columns: [paused, paused_at, started_at, version, updated_at]
      }
    ) {
      id
      lead_id
    }
  }
`;

export const insertLeadTouchpointLog = gql`
  mutation insertLeadTouchpointLog($object: lead_touchpoint_log_insert_input!) {
    insert_lead_touchpoint_log_one(
      object: $object
      on_conflict: {
        constraint: lead_touchpoint_log_lead_id_day_channel_slot_key
        update_columns: [
          status
          skip_reason
          skip_notes
          lead_contact_id
          call_outcome
          slot
        ]
      }
    ) {
      id
    }
  }
`;

export const cadenceStateFragment = gql`
  fragment LeadCadenceStateFields on lead_cadence_state {
    id
    started_at
    paused
    paused_at
    version
    touchpoint_logs(order_by: { created_at: asc }) {
      id
      day
      channel
      status
      skip_reason
      skip_notes
      call_outcome
      slot
      created_at
    }
  }
`;
